import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/view/Dashboard'
import OrderPending from '@/components/view/OrderPending'
import OrderInfo from '@/components/view/OrderInfo'
import OrderCurrent from '@/components/view/OrderCurrent'
import Zone from '@/components/view/Zone'
import TransferPending from '@/components/view/TransferPending'
import TransferCompleted from '@/components/view/TransferCompleted'
import Search from '@/components/view/Search'
import AddressBook from '@/components/view/AddressBook'
import PendingAccounts from '@/components/view/PendingAccounts'
import Users from '@/components/view/Users'
import Logs from '@/components/view/Logs'
import Reports from '@/components/view/Reports'
import Settings from '@/components/view/Settings'
import Login from '@/components/view/Login'
import Dev from '@/components/view/Dev'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/OrderCurrent'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Orderpending',
      name: 'OrderPending',
      component: OrderPending,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/OrderInfo',
      name: 'OrderInfo',
      component: OrderInfo,
      meta: {
        requiresAuth: true
      },
      props: (route) => ({ query: route.query.orderId })
    },
    {
      path: '/OrderCurrent',
      name: 'OrderCurrent',
      component: OrderCurrent,
      meta: {
        requiresAuth: true
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/Zone',
      name: 'Zone',
      component: Zone,
      meta: {
        requiresAuth: true
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/TransferPending',
      name: 'TransferPending',
      component: TransferPending,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/TransferCurrent',
      name: 'TransferCurrent',
      component: TransferCompleted,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/PendingAccounts',
      name: 'PendingAccounts',
      component: PendingAccounts,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/AddressBook',
      name: 'AddressBook',
      component: AddressBook,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Logs',
      name: 'Logs',
      component: Logs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/Dev',
      name: 'Dev',
      component: Dev,
      meta: {
        requiresAuth: true
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // console.log('>>> to', to)
    // console.log('>>> from', from)
    return { x: 0, y: 0 }
  }
})
